import { Component, OnInit, SecurityContext } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ParamContext } from '../../../shared/service/param.context';
import { GermplasmDetailsContext } from '../../germplasm-details.context';
import { GermplasmDetailsPopupService } from '../../germplasm-details-popup.service';
import { UrlService } from '../../../shared/service/url.service';

@Component({
    selector: 'jhi-germplasm-basic-details-audit-modal',
    templateUrl: './germplasm-basic-details-audit-modal.component.html',
})
export class GermplasmBasicDetailsAuditModalComponent implements OnInit {

    gid: number;

    readonly url: SafeResourceUrl;

    constructor(private route: ActivatedRoute,
                private sanitizer: DomSanitizer,
                private context: ParamContext,
                private germplasmDetailsContext: GermplasmDetailsContext,
                private activeModal: NgbActiveModal,
                private urlService: UrlService
    ) {
        const url = '/ibpworkbench/controller/jhipster#/germplasm/audit?restartApplication&modal' +
        '&cropName=' + context.cropName +
        '&programUUID=' + context.programUUID +
        '&gid=' + this.germplasmDetailsContext.gid;

        const safeUrl = this.urlService.buildSafeUrl(url);
        // Fall back to a blank page if the URL is not on the allowlist.
        this.url = safeUrl !== null
            ? this.sanitizer.bypassSecurityTrustResourceUrl(safeUrl)
            : this.sanitizer.bypassSecurityTrustResourceUrl('about:blank');
    }

    ngOnInit() {
        (<any>window).closeModal = () => {
            this.activeModal.close();
        };
    }

    dismiss() {
        this.activeModal.close();
    }
}

@Component({
    selector: 'jhi-germplasm-basic-details-popup',
    template: ''
})
export class GermplasmBasicDetailsAuditPopupComponent implements OnInit {

    constructor(private modalService: NgbModal,
                private germplasmDetailsContext: GermplasmDetailsContext,
                private route: ActivatedRoute,
                private germplasmDetailsPopupService: GermplasmDetailsPopupService) {
    }

    ngOnInit(): void {
        this.germplasmDetailsContext.gid = Number(this.route.snapshot.paramMap.get('gid'));
        if (this.germplasmDetailsContext.openedFromWorkbench) {
            this.germplasmDetailsPopupService.close();
        }
        const modal = this.modalService.open(GermplasmBasicDetailsAuditModalComponent as Component, { size: 'lg', backdrop: 'static' });
        modal.componentInstance.gid = this.germplasmDetailsContext.gid;
        if (this.germplasmDetailsContext.openedFromWorkbench) {
            modal.result.then((result) => {
                this.germplasmDetailsPopupService.open(this.germplasmDetailsContext.gid, 'germplasm-basic-details');
            }, () => {
                this.germplasmDetailsPopupService.open(this.germplasmDetailsContext.gid, 'germplasm-basic-details');
            });
        }
    }

}
